import { SVGProps } from "react";

const STITrello = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" aria-label="Trello" role="img" viewBox="0 0 512 512" fill="#fff" width="1em" height="1em" {...props}><rect width={512} height={512} rx="15%" fill="#0079bf" /><rect height={188} rx={23} width={132} x={284} y={95} /><rect height={296} rx={23} width={132} x={97} y={95} /></svg>;

export { STITrello };